module.exports = __webpack_public_path__ + "static/media/352661__foolboymedia__complete-chime.d138b83a.mp3";